<template>
  <div>
    <div class="login_box register_box">
      <div class="main_box">
        <div class="title clearfix">
          <span class="lang_register">{{$t('menu.register')}}</span>
          <router-link to="/login" class="fr lang_id" tag="a">{{$t('menu.id')}} ></router-link>
        </div>
        <div class="xcontent">
          <div class="box">
            <div class="row choose_type">
              <div class="col-md-4 col-xs-6" v-for="(item,index) in typeList" :key="index"><span class="select" v-bind:class="{active:index+1==defaultType}" @click="chooseType(index)"></span>{{item.name}}</div>
            </div>
            <!-- 企业注册 -->
            <div :class="{hide:defaultType==3}">
              <div class="input_box"><span class="lang_companyName">企业名称：</span><input type="text" placeholder="请输入企业名称" v-model="companyName"></div>
              <div class="mgb20">
                <div class="upload_btn" @click="uploadLogo"><i class="xicon xicon_upload"></i>上传企业logo</div>
                <div class="upload_btn"  @click="uploadLogo2"><i class="xicon xicon_upload"></i>上传营业执照</div>
                <input type="file" style="display: none"  id="cmpLogo" @change="changeLogo">
                <input type="file" style="display: none" id="cmpLogo2" @change="changeLogo2">
                <div class="imglogo">
                  <div class="example">{{imgCompanyLogoName}}</div>
                  <div class="example">{{imgCompanyLicenseName}}</div>
                 
                </div>
              </div>
              <div class="input_box"><span class="lang_userinfo1">用户名：</span><input type="text" placeholder="请输入用户名(用户名只能由数字或字母组成)" v-model="accountName"></div>
              <div class="input_box"><span class="lang_userinfo1">手机号：</span><input type="text" placeholder="请输入手机号" v-model="phoneNo"></div>
              <div class="clearfix" style="margin-bottom:20px;">
                <div class="input_box input_box_left fl"><span class="lang_userinfo5">验证码：</span><input type="text" placeholder="请输入验证码" v-model="checkCode"></div>
                <div class="xbtn2 input_box_right fr getcode" @click="getCheckCode">{{timeDetail}}</div>
              </div>
              <div class="input_box"><span class="lang_userinfo2">密码：</span><input type="password" placeholder="请输入密码" v-model="password"></div>
              <div class="input_box"><span class="lang_userinfo4">确认密码：</span><input type="password" placeholder="请确认密码" v-model="agpassword"></div>
              
            </div>
            <!-- 个人注册 -->
            <div class="hide" :class="{show:defaultType==3}">
              <div class="input_box"><span class="lang_userinfo1">用户名：</span><input type="text" placeholder="请输入用户名(用户名只能由数字或字母组成)" v-model="accountName"></div>
              <div class="input_box"><span class="lang_userinfo6">真实姓名：</span><input type="text" placeholder="请输入真实姓名" v-model="realName"></div>
              <div class="input_box"><span class="lang_userinfo7">身份证号：</span><input type="text" placeholder="请输入身份证号" v-model="idCard"></div>
              
              <div class="input_box"><span class="lang_userinfo1">手机号：</span><input type="text" placeholder="请输入手机号" v-model="phoneNo"></div>
              <div class="clearfix" style="margin-bottom:20px;">
                <div class="input_box input_box_left fl"><span class="lang_userinfo5">验证码：</span><input type="text" placeholder="请输入验证码" v-model="checkCode"></div>
                <div class="xbtn2 input_box_right fr getcode" @click="getCheckCode">{{timeDetail}}</div>
              </div>
              <div class="input_box"><span class="lang_userinfo8">邮箱：</span><input type="text" placeholder="请输入邮箱" v-model="email"></div>
              <!-- <div class="clearfix mgb20">
                <div class="input_box input_box_left fl"><span>验证码：</span><input type="password" placeholder="请输入验证码" v-model="checkCode"></div>
                <div class="input_box_right fr">发送验证码</div>
              </div> -->
              <div class="input_box"><span>密码：</span><input type="password" placeholder="请输入密码" v-model="password"></div>
              <div class="input_box"><span>确认密码：</span><input type="password" placeholder="请确认密码" v-model="agpassword"></div>
            </div>

            <div class="checkbox">
                <label>
                  <input type="checkbox"  v-bind:checked="isChecked" @click="handleDisabled">
                  <span class="userProcol2 lang_agree">{{$t('menu.agree')}}<a @click="toUseragree" class="userProcol2" style="color:#234EA0">{{$t('menu.agree2')}}</a></span>
                  
                </label>
            </div>
            <div class="userProcol2" style="color:#234EA0">             
                  ( {{$t('menu.careful')}} )
            </div>
              <div class="xbtn lang_register" @click="getRegister">{{$t('menu.register')}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      isChecked:false,//是否选中协议
        typeList:[
          {name:'园区企业注册'},
          {name:'非园区企业注册'},
          {name:'个人注册'}
        ],
        defaultType:1,
        checkImg:'',
        companyName:'',//公司名称
        accountName:'',//用户名
        password:'',//密码
        imgCompanyLogo:'',//企业logo
        imgCompanyLicense:'',//营业执照
        agpassword:'',//确认密码
        checkCode:'',//验证码
        verifyId:'',//验证码id
        imgCompanyLogoName:'',//企业logo照片名字
        imgCompanyLicenseName:'',//营业执照照片名字
        email:'',//邮箱
        phoneNo:'',//手机号
        realName:'',//真实姓名
        idCard:'',//身份证
        timeDetail:'获取验证码',
        countdown:30,
    }
  },
  methods:{
        chooseType: function(index){
          this.defaultType = index+1;
        },
        // 获取验证码
        getCheckCode() {
          if(this.phoneNo == ''){
            layer.msg('请输入手机号', {
                  time: 1500 
              }); 
            return;         
          }
          var postData={
            'phoneNum':this.phoneNo,
            'type':1,
          }
          this.$http.post(this,'/noAuth/user/smsCheckCode',this.$Qs.stringify(postData)).then(res=>{
            if(res){
              layer.msg('发送成功', {
                      time: 1000 
                    }, ()=>{
                      this.getTime();
                    }); 
            }
          })
        },
        getTime(){
          var that = this;
          var obj =document.getElementsByClassName('getcode');   
          if (this.countdown == 0) { 
                 obj.disabled = false;  
                $(".getcode").css("background","#234EA0")
                 this.timeDetail="获取验证码"; 
                 this.countdown = 30;
                 return;
           } else { 
               obj.disabled = true;      
              //  obj.style.setProperty('background','#666'); 
                  $(".getcode").css("background","#999")
               this.timeDetail= this.countdown +"S后重新发送"; 
               this.countdown--; 
               setTimeout(function() { 
                 that.getTime(); 
                     }
                ,1000) 
            }
        },
        handleDisabled:function(){
          this.isChecked = !this.isChecked;
          if(this.isChecked==true){
            this.isDisabled =  true;
          }
          else{
              this.isDisabled =  false;
          }
        },
        toUseragree(){
          this.$router.push({path:'/user-agree'});
        },
        // 注册
        getRegister: function () {
          var that = this
          var partn=/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;//密码正则表达式
          var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;  //身份证正则表达式
          var email = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;//邮箱
          var number = /^[1][3,4,5,7,8][0-9]{9}$/;//手机
          var username = /^[0-9a-zA-Z]+$/;//用户名
          if(this.defaultType == 1 || this.defaultType==2){
          // var that = this;
          if(this.companyName == ''){
            layer.msg('请输入企业名称', {
                  time: 1500 
              }); 
            return;         
          }
          else if(this.imgCompanyLogo == ''){
            layer.msg('请上传企业logo', {
                  time: 1500 
              });
            return;
          }else if(this.imgCompanyLicense == ''){
            layer.msg('请上传企业的营业执照', {
                  time: 1500 
            });
            return;
          }else if(this.accountName==''){
            layer.msg('请输入用户名', {
                  time: 1500 
            });
            return;
          }else if(!username.exec(this.accountName)){
            layer.msg('用户名只能由数字或字母组成', {
                  time: 1500 
            });
            return;
          }else if(this.phoneNo==''){
              layer.msg('手机号不能为空', {
                  time: 1500 
              });
              return;
          }            
          else if( !number.exec(this.phoneNo)){
              layer.msg('您输入的手机号格式不正确', {
                  time: 1500 
              });
              return;
            }else if(this.checkCode==''){
              layer.msg('请输入验证码', {
                  time: 1500 
              });
              return;
            }
          else if(this.password==''){
            layer.msg('密码不能为空', {
                  time: 1500 
            });
            return;
          }else if(this.agpassword==''){
            layer.msg('确认密码不能为空', {
                  time: 1500 
            });
            return;
          }else if(this.password != this.agpassword){
            layer.msg('密码和确认密码不一致', {
                  time: 1500 
            });
            return;
          }
          else if(this.isChecked!=true) {
            layer.msg('请先阅读并接受用户协议', {
                  time: 1500 
            });
            return;
          }     
            var formFile = new FormData();
            formFile.append("type", this.defaultType);  
            formFile.append("companyName", this.companyName);  
            formFile.append("accountName", this.accountName);  
            formFile.append("accountPwd", this.password); 
            formFile.append("phoneNo", this.phoneNo);  
            formFile.append("checkCode", this.checkCode);  
            // formFile.append("verifyId", this.verifyId);  
            formFile.append("imgCompanyLogo", this.imgCompanyLogo);  
            formFile.append("imgCompanyLicense", this.imgCompanyLicense);  
            formFile.append("realName",this.companyName);  
            var da = formFile;            
            //return;

            this.$http.post(that,'/noAuth/user/register',da).then(res=>{
              if(res){
                layer.confirm('提示信息', {
                     content: "注册成功！等待管理员审核",
                      btn: ['确定'] 
                      ,btn1: function(index, layero){
                        layer.close(index)
                        setTimeout(()=>{
                          that.$router.push('/')
                        },200);
                      }
                    });
              }
            })
          }else if(this.defaultType == 3){
            
            if(this.accountName == ''){
              layer.msg('请输入用户昵称', {
                  time: 1500 
              });
              return;         
            }else if(!username.exec(this.accountName)){
              layer.msg('用户名只能由数字或字母组成', {
                  time: 1500 
              });
              return;
            }
            else if(this.realName==''){
              layer.msg('请输入真实姓名', {
                  time: 1500 
              });
              return;
            }else if(this.idCard==''){
              layer.msg('请输入身份证号', {
                  time: 1500 
              });
              return;
            }
            else if( !reg.exec(this.idCard)){
              layer.msg('您输入的身份证不合法', {
                  time: 1500 
              });
              return;
            }else if(this.phoneNo==''){
              layer.msg('手机号不能为空', {
                  time: 1500 
              });
              return;
            }            
            else if( !number.exec(this.phoneNo)){
              layer.msg('您输入的手机号格式不正确', {
                  time: 1500 
              });
              return;
            }else if(this.checkCode==''){
              layer.msg('请输入验证码', {
                  time: 1500 
              });
              return;
            }
            else if(this.email==''){
              layer.msg('邮箱不能为空', {
                  time: 1500 
              });
              return;
            }
            else if( !email.exec(this.email)){
              layer.msg('您输入的邮箱格式不正确', {
                  time: 1500 
              });
              return;
            }
            else if(this.password==''){
              layer.msg('密码不能为空', {
                  time: 1500 
              });
              return;
            }else if(this.agpassword==''){
              layer.msg('确认密码不能为空', {
                  time: 1500 
              });
              return;
            }else if(this.password != this.agpassword){
              layer.msg('密码和确认密码不一致', {
                  time: 1500 
              });
              return;
            } 
            else if(this.isChecked!=true) {
              layer.msg('请先阅读并接受用户协议', {
                  time: 1500 
              });
              return;
            }    
              var formFile2 = new FormData();
              formFile2.append("type", this.defaultType);   
              formFile2.append("accountName", this.accountName); 
              formFile2.append("realName", this.realName);    
              formFile2.append("accountPwd", this.password);  
              formFile2.append("checkCode", this.checkCode);  
              // formFile2.append("verifyId", this.verifyId);  
              formFile2.append("email", this.email);  
              formFile2.append("idCard", this.idCard);  
              formFile2.append("phoneNo", this.phoneNo);  
              var da2 = formFile2;   
              console.log('this');
              this.$http.post(that,'/noAuth/user/register',da2).then(res=>{
                if(res){
                  layer.confirm('提示信息', {
                      content: "注册成功！",
                        btn: ['确定'] 
                        ,btn1: function(index, layero){
                          layer.close(index)
                          setTimeout(()=>{
                            that.$router.push('/')
                          },200);
                        }
                      });
                }
              })         
              // return;
              // $.ajax({            
              //   url: this.apiPath + '/noAuth/user/register',
              //   type: 'POST',
              //   data:da2,
              //   processData:false,  
              //   contentType: false,
              //   success: function (res) {
              //     layer.confirm('提示信息', {
              //        content: "注册成功！等待管理员审核",
              //         btn: ['确定'],
              //         btn1: function(index, layero){
              //           setTimeout("window.location.href='index.html'",200);
              //         }
              //       });       
              //   },
              //   error:function(res){
              //     console.log(res);
              //   }
              // })
            }        
       },
        // 上传企业logo图片
        uploadLogo:function(){
          $('#cmpLogo').click();
        },
        // 上传营业图片
        uploadLogo2:function(){
          $('#cmpLogo2').click();
        },
        changeLogo:function(e){         
          this.imgCompanyLogo = e.target.files[0];
          this.imgCompanyLogoName=e.target.files[0].name;
        },
        changeLogo2:function(e){
          this.imgCompanyLicense = e.target.files[0];
          this.imgCompanyLicenseName=e.target.files[0].name;         
        },
      },
};
</script>
<style lang="less">
.imglogo > img {
  width: 100px;
  height: 100px;
  margin-top: 15px;
  margin-right: 15px;
}
.example {
  margin-top: 15px;
}
</style>




// WEBPACK FOOTER //
// src/pages/register.vue